import { PaymentElement, useElements, useStripe } from '@stripe/react-stripe-js'
import React, { useImperativeHandle, useLayoutEffect, useRef } from 'react'

import { STRIPE_PAYMENT_ELEMENT_OPTIONS } from '@/pages/market-shop/market-shop.constants'

import { StripePaymentInnerProps } from './stripe-payment.types'

// Note: Renders fields only — parent section matches OrderReceive card; no extra bordered box.
export const StripePaymentFields = ({ ref }: StripePaymentInnerProps) => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const stripe = useStripe()
  const elements = useElements()

  const readyPromiseRef = useRef<Promise<void>>(null)
  const readyResolveRef = useRef<VoidFunction>(null)

  useLayoutEffect(() => {
    if (readyPromiseRef.current) return
    readyPromiseRef.current = new Promise((resolve) => {
      readyResolveRef.current = resolve
    })
  }, [])

  useImperativeHandle(
    ref,
    () => ({
      container: wrapperRef.current,
      elements,
      stripe,
      waitUntilReady: () => readyPromiseRef.current ?? Promise.resolve(),
    }),
    [stripe, elements],
  )

  return (
    <div ref={wrapperRef}>
      <PaymentElement
        options={{ ...STRIPE_PAYMENT_ELEMENT_OPTIONS }}
        onReady={() => {
          readyResolveRef.current?.()
        }}
      />
    </div>
  )
}
